module.exports = __webpack_public_path__ + "static/media/logo_lmc@2x.b62e50a8.png";